const Builder = require('../BuilderBase');

module.exports = class DataAggregation extends Builder {
    constructor(title, properties) {
        super('dataView_DataAggregation', title, properties);
    }
};
